var React = require('react');

function ToolAftereffects (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"fill-foreground"},[React.createElement("path",{"d":"M13.9,9.5h-3.5L5.7,26.5h3.2l1.3-4.6h4.2l1.3,4.6h3.2L13.9,9.5z M10.3,19.3l1.6-6.4l1.4,6.4H10.3z","key":0}),React.createElement("path",{"d":"M30.3,21.1v-2.8c0-2.9-2.1-4.8-5.2-4.8c-3.3,0-5.2,1.9-5.2,5.4v2.2c0,3.3,2.1,5.4,5.4,5.4c3.1,0,5.1-1.8,5.1-4.4v-0.2h-2.2\n\t\t\tl-0.3,0.2v0.3c0,1.8-1.8,1.9-2.6,1.9c-2,0-2.9-1-2.9-3.2l0,0C22.4,21.1,30.3,21.1,30.3,21.1z M27.8,18.4v0.4h-5.2\n\t\t\tc0-2,0.9-2.9,2.9-2.9C26.9,15.9,27.8,16.8,27.8,18.4z","key":1})]));
}

ToolAftereffects.defaultProps = {"version":"1.1","width":"36","height":"36","viewBox":"0 0 36 36"};

module.exports = ToolAftereffects;

ToolAftereffects.default = ToolAftereffects;
